import { storage } from '../../services/storage/storage.service';

const LIMIT_VERIFICATION_REQUEST_STORE_KEY = 'limit_mobile_verification_request_store_key';
export const MOBILE_VERIFICATION_COUNTDOWN_STORAGE_KEY = 'mobile_verification_countdown_storage_key';
export const MOBILE_VERIFICATION_PER_USER_RATE_LIMIT = 3;
const MOBILE_VERIFICATION_PER_USER_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

export const mobileVerificationStorage = {
  constructKey(userId: string): string {
    return `${LIMIT_VERIFICATION_REQUEST_STORE_KEY}_${userId}`;
  },

  // These limit the request to verify the 5 digit code.
  setVerifyCodeRequestSent: () => {
    storage.setItem(MOBILE_VERIFICATION_COUNTDOWN_STORAGE_KEY, JSON.stringify(Date.now()));
  },

  clearVerifyCodeRequestSent: () => {
    storage.removeItem(MOBILE_VERIFICATION_COUNTDOWN_STORAGE_KEY);
  },

  // Check if the mobile verification request is allowed
  isMobileRequestAllowed: (userId: string): boolean => {
    const key = mobileVerificationStorage.constructKey(userId);
    const item = storage.getItem(key);

    const { requestTimes, lastRequest } = JSON.parse(item || '{}');

    const isExpired = Date.now() - lastRequest > MOBILE_VERIFICATION_PER_USER_DURATION_MS;

    if (isExpired) {
      mobileVerificationStorage.removeMobileRequest(key);
      return true;
    }

    if (requestTimes >= MOBILE_VERIFICATION_PER_USER_RATE_LIMIT) {
      return false;
    }

    return true;
  },

  getCurrentMobileRequestRquid: (userId: string): string | null => {
    const key = mobileVerificationStorage.constructKey(userId);
    const item = storage.getItem(key);
    const { rquid } = JSON.parse(item || '{}');
    return rquid || null;
  },

  setCurrentMobileRequest: (userId: string, requestTimes: number, rquid: string) => {
    storage.setItem(
      mobileVerificationStorage.constructKey(userId),
      JSON.stringify({
        lastRequest: Date.now(),
        requestTimes,
        userId,
        rquid,
      }),
    );
  },

  removeMobileRequest: (key: string) => {
    storage.removeItem(key);
  },

  incrementMobileRequest: (userId: string, rquid: string) => {
    const key = mobileVerificationStorage.constructKey(userId);
    const item = storage.getItem(key);
    const { userId: existingUserId, requestTimes: existingRequestTimes } = JSON.parse(item || '{}');

    if (!existingUserId && !existingRequestTimes) {
      return mobileVerificationStorage.setCurrentMobileRequest(userId, 0, rquid);
    }

    const incrementedTimes = existingRequestTimes + 1;
    mobileVerificationStorage.setCurrentMobileRequest(userId, incrementedTimes, rquid);
  },
};
